import { combineReducers } from 'redux';

// Reducers
import busyIndicatorReducer from '../busy-indicator/busy-indicator-reducer';
import consoleReducer from '../console/console-reducer';

const CombinedReducers = combineReducers({
    busyIndicatorReducer,
    consoleReducer
});

export default CombinedReducers;



// WEBPACK FOOTER //
// ./containers/app/combined-reducers.js